export default "__VITE_ASSET__DLEAY3ox__"